import CommonFormProvider from "src/context/Modal/Form/CommonForm.provider";
import AskPromotion from "../_AskPromotion";
import CheckPromotion from "../_CheckPromotion";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface IDspmPromotionUIProps {
  promotionCode: string;
  setPromotionCode: Dispatch<SetStateAction<string>>;
  startDate: string;
  endDate: string;
  setStartDate: Dispatch<SetStateAction<string>>;
  setEndDate: Dispatch<SetStateAction<string>>;
  isCheckPromotionCode: string;
  setIsCheckPromotionCode: Dispatch<SetStateAction<string>>;
  promotionApply: ({
    issueAppList,
    referralId,
  }: {
    issueAppList: string[];
    referralId: string;
  }) => void;
  productName: string;
  toggleAskPromotionOn: boolean;
  setToggleAskPromotionOn: Dispatch<SetStateAction<boolean>>;
}
const DspmPromotionUI = ({
  promotionCode,
  setPromotionCode,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  isCheckPromotionCode,
  setIsCheckPromotionCode,
  promotionApply,
  productName,
  toggleAskPromotionOn,
  setToggleAskPromotionOn,
}: IDspmPromotionUIProps) => {
  const { t } = useTranslation();
  return (
    <div className="containerBox">
      <div className="container">
        <div className="site">
          <h3 className="site__title">
            {!toggleAskPromotionOn
              ? productName + " Cloud Premium"
              : t("siteType.premium.askTitle")}
          </h3>
          <p className="site__desc">
            {!toggleAskPromotionOn
              ? t("siteType.premium.subTitle")
              : t("siteType.premium.askSubTitle")}
          </p>
          <div>
            {toggleAskPromotionOn ? (
              <CommonFormProvider>
                <AskPromotion
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  toggleAskPromotionOn={toggleAskPromotionOn}
                  setToggleAskPromotionOn={setToggleAskPromotionOn}
                />
              </CommonFormProvider>
            ) : (
              <CommonFormProvider>
                <CheckPromotion
                  promotionCode={promotionCode}
                  setPromotionCode={setPromotionCode}
                  isCheckPromotionCode={isCheckPromotionCode}
                  toggleAskPromotionOn={toggleAskPromotionOn}
                  setToggleAskPromotionOn={setToggleAskPromotionOn}
                  setIsCheckPromotionCode={setIsCheckPromotionCode}
                  promotionApply={promotionApply}
                />
              </CommonFormProvider>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DspmPromotionUI;
